import 'slick-carousel'
import './related-products-carousel'
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import { collectionOptions } from './fancybox-options'

$('[data-fancybox]').fancybox(collectionOptions);

var i;
var homeComponentsLength = $("#home-components").data("length");

for (i = 0; i < homeComponentsLength; i++) {
    $('#home-slider-' + i).slick({
        lazyLoad: 'ondemand',
        arrows: true,
        // rows: 0,
        infinite: true,
        autoplay: true,
        speed: 2000,
        pauseOnHover: false,
        autoplaySpeed: 2500,
        fade: true,
        appendArrows: "#home-slider-" + i + "-arrows",
        prevArrow: `<button class="slick-arrow-prev"><i class="icon-arrow-left"></button>`,
        nextArrow: `<button class="slick-arrow-next"><i class="icon-arrow-right"></button>`,
    });
}

setTimeout(() => {
    new Swiper(".home-carousel", {
        modules: [Navigation, Autoplay],
        loop: true,
        spaceBetween: 5,
        slidesPerView: 1.2,
        centeredSlides: true,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            576: {
                slidesPerView: 1.6,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 2.3,
            },
            1280: {
                centeredSlides: false,
                slidesPerView: 4,
            },
        }
    });
}, 1500);